import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import TeamList from "views/pages/team/TeamList";
import AddTeam from "views/pages/team/AddTeam";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import Utility from "@core/helper/utility";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const Team = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [teamList, setTeamList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteTeamMember)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = teamList.filter((o) => o.id !== id);
            setTeamList(filter);
            fetchTeamMemberList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setType(type);
    setSearchText("");
    if (id) {
      const findList = teamList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const team = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(team[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    fetchTeamMemberList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchTeamMemberList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getTeamMember)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setTeamList(results);
          setTotalRecord(totalCount);
        } else {
          setTeamList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitTeamMember = () => {
    fetchTeamMemberList();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Team
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <TeamList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            teamList={teamList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchText={searchText}
            setSearchText={setSearchText}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      <AddTeam
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={type === "edit" ? "Update Team" : "Add Team"}
        onSubmitTeamMember={submitTeamMember}
        updateData={updateData}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default Team;
